import styled from 'styled-components';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
// import { CalculatorSection } from 'components/parts/home/calculator/CalculatorSection';
import React from 'react';
import { SSRConfig } from 'next-i18next';
import { FulfillmentServiceTitle } from 'components/parts/fulfillment-service/canada/FulfillmentServiceTitle';
import { BasicPage } from 'components/parts/BasicPage';
import dynamic from 'next/dynamic';
import { Button } from 'components/atoms/Button';

const TestimonialsSection = dynamic(() => import('components/parts/home/TestimonialsSection'));

const ContactUsContainer = styled.div`
    text-align: center;
    margin-bottom: 75px;
`;

const ServicesContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 75px;
`;

function Home(): React.ReactNode {
    return (
        <BasicPage
            metaTitle="MagicShip: 3PL eCommerce Fulfillment Service Center in Canada"
            metaDescription="Let us handle your shipping through our Fulfillment Centers in Canada for fast &amp; cheap shipping within Canada, and cheaper international shipping. Replenish Amazon FBA stock in Canada."
        >
            <FulfillmentServiceTitle />
            <ServicesContainer>
                <h2>3PL Fulfillment Services</h2>
                <ul>
                    <li>
                        We <strong>fulfill your eCommerce orders</strong> (Shopify, Amazon FBM, WooCommerce, Wix etc.)
                        for a fee of CAD$4.50 per order.
                    </li>
                    <li>
                        <strong>Same-day shipping</strong> on orders placed by 3 PM local warehouse time
                    </li>
                    <li>Replenish Amazon FBA stock. (fee: hourly wage)</li>
                    <li>Pallet storage. (CAD$25/pallet/month)</li>
                    <li>
                        Benefit from the <strong>low shipping rates</strong> we have with different carriers (Canada
                        &amp; international).
                    </li>
                    <li>
                        <strong>Fast delivery</strong> within Canada: avg. 1-3 business days
                    </li>
                </ul>
            </ServicesContainer>
            <ContactUsContainer>
                <Button type="link" href="mailto:contact@magicship.com" kind="primary" fill="solid" size="lg">
                    Contact Us
                </Button>
            </ContactUsContainer>

            {/* TODO 
            Allow shipping rates to be seen for the fulfillment service.
            Rename TRY IT OUT to GET FULFILLMENT FEE
            Hide "FROM" and in the backend, pull rates from both Calgary
            and QC warehouses, and show the cheapest rate as a one liner,
            e.g.: "The total cost is $17.48, which includes both the shipping cost and our fulfillment fee."
            Refactor CalculatorSection accordingly as a part that doesn't pertain only to 'home'
            and according to the QC/Calg "FROM" for the fulfillment service etc.
            */}
            {/* <CalculatorSection /> */}

            <TestimonialsSection />
        </BasicPage>
    );
}

export async function getStaticProps({ locale }: { locale: string }): Promise<{ props: SSRConfig }> {
    return {
        props: {
            ...(await serverSideTranslations(locale, ['common', 'home', 'shipping'])),
        },
    };
}

export default Home;
